/** Ported from Clarity `apps/web/src/shared/utils/documentUtils.ts` (commit `9015ce88c`). */
/**
 * The document formats whose text the send path extracts in the browser (brain's `isExtractableDocument`, first read
 * at brain `e5fac7ff8`).
 *
 * **Narrower than `FILE_TYPES.DOCUMENT`, and the gap is the point.** A PDF is a document and is not
 * here: its text is extracted server-side, so it is pre-uploaded like an image. Everything listed
 * below is read where the reader is sitting, which is why the composer does not pre-upload it at all
 * (spec → TR-2(c)).
 *
 * `.htm` is here and `text/htm` is not, because there is no such MIME type — a `.htm` file arrives
 * as `text/html` or as nothing at all. Clarity added the extension after a review found the same
 * gap; the two lists are its own, kept as they are.
 *
 * `.txt` and `.md` are deliberately absent from both lists: they are already text, so
 * `isClarityChatTextBasedFile` claims them one step earlier.
 */
export const CLARITY_CHAT_EXTRACTABLE_DOCUMENT = {
	MIME_TYPES: [
		/** `.docx` */
		'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
		/** `.xlsx` */
		'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
		/** `.xls` */
		'application/vnd.ms-excel',
		/** `.pptx` */
		'application/vnd.openxmlformats-officedocument.presentationml.presentation',
		'text/csv',
		'text/html',
		'application/json',
	],
	EXTENSIONS: ['.docx', '.xlsx', '.xls', '.csv', '.pptx', '.html', '.htm', '.json'],
} as const;
